import {computed} from 'vue';
import {useAuth} from '#imports';

/**
 * Thin wrapper around the auth store for the unlogged navbar.
 * Prefer this over a local user store so session state stays in sync with `useAuth`.
 */
export function useNavbarUser() {
    const authStore = useAuth();

    const user = computed(() => authStore.user);
    const loggedIn = computed(() => authStore.loggedIn);
    const isCompany = computed(() => authStore.currentIdentityIsClient);

    return {
        isCompany,
        loggedIn,
        user,
    };
}
